<template>
  <div>
    <ContentHeader title="Profile" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-xl-3">
            <div class="card card-danger card-outline">
              <div class="card-body box-profile">
                <div class="text-center" v-if="user.image">
                  <img
                    class="profile-user-img img-fluid img-circle"
                    :src="`${$backendURL + user.image}`"
                    alt="User profile picture"
                  />
                </div>
                <div class="text-center" v-else>
                  <img
                    src="@/assets/svg/male.svg"
                    class="profile-user-img img-fluid img-circle"
                    alt="User profile picture"
                  />
                </div>

                <h3 class="profile-username text-center">
                  {{ user.username }}
                </h3>

                <p class="text-muted text-center">{{ user.email }}</p>

                <ul class="list-group list-group-unbordered mb-3">
                  <li class="list-group-item">
                    <b>Phone</b> <a class="float-right">{{ user.phone }}</a>
                  </li>
                </ul>

                <router-link
                  :to="{ name: 'UpdateProfile', params: { id: user.id } }"
                  class="btn btn-utama btn-block rounded-pill"
                >
                  <b>Change</b>
                </router-link>

                <router-link
                  :to="{ name: 'ChangePassword', params: { id: user.id } }"
                  class="btn btn-outline-utama btn-block rounded-pill"
                >
                  <b>Change Password</b>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-8 col-xl-9">
            <div class="card card-danger">
              <div class="card-header">
                <h3 class="card-title">About Me</h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <strong
                  ><i class="fas fa-building mr-1"></i> Company Name</strong
                >

                <p class="text-muted">
                  {{ user.company_name }}
                </p>

                <hr />

                <strong
                  ><i class="fas fa-map-marker-alt mr-1"></i> Address</strong
                >

                <p class="text-muted">{{ user.address }}</p>

                <hr />

                <strong
                  ><i class="fas fa-phone-square mr-1"></i> PIC</strong
                >

                <p class="text-muted">
                  {{ user.pic }}
                </p>

                <hr />

                <strong><i class="fas fa-flag mr-1"></i> Country</strong>

                <p class="text-muted">
                  {{ user.country }}
                </p>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style>
@import "../../../public/custom_styles/profile.css";
</style>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";

export default {
  components: {
    ContentHeader,
  },
  created() {
    document.title = "Profile - Manager Cabang";
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>
